"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_RETURNS = void 0;
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var returnsFields_1 = require("./returnsFields");
exports.GET_RETURNS = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetReturns {\n    account {\n      returns ", "\n    }\n  }\n"], ["\n  query GetReturns {\n    account {\n      returns ", "\n    }\n  }\n"])), returnsFields_1.RETURNS_FIELDS);
var templateObject_1;
